import React, { ReactNode } from "react";

import ACModalV2, { ACModalV2Props } from "ac-components/ac-modal/ACModalV2";

export type ModalConfig = Pick<
  ACModalV2Props,
  | "closable"
  | "mask"
  | "onClose"
  | "width"
  | "defaultPlacement"
  | "settingsPrefixKey"
  | "resize"
  | "fullHeight"
> & {
  content: ReactNode | ReactNode[];
  id?: string;
};

export default function ACModalRenderer({
  configs,
  onClose,
}: {
  configs: ModalConfig[];
  onClose: (index: ModalConfig["id"], state: unknown) => void;
}) {
  return (
    <>
      {configs.map(
        ({
          content,
          closable,
          mask,
          width,
          defaultPlacement,
          id,
          settingsPrefixKey,
          resize,
          fullHeight,
        }) => {
          return (
            <ACModalV2
              key={id}
              closable={closable}
              mask={mask}
              width={width}
              defaultPlacement={defaultPlacement}
              settingsPrefixKey={settingsPrefixKey}
              onClose={(state) => onClose(id, state)}
              resize={resize}
              fullHeight={fullHeight}
            >
              {content}
            </ACModalV2>
          );
        },
      )}
    </>
  );
}
